export const DocumentRelevance = {
  BUSINESS: 'BUSINESS',
  PRIVATE: 'PRIVATE',
  MIX: 'MIX',
}
